import { getQueryParam } from '../shared/utils.js';
import { elements } from './elements.js';
import { hiddenClass, resourceTypeParam, corporateDocsValue } from '../../../config.js';
import { expandFilterMenu } from '../../../includes/collapseFilterGroup.js';
import Choices from 'choices.js';

export const preloadFormFields = () => {
    const {
        searchInput,
        sortDropdown,
        dropdowns,
        searchTypeRadios,
        updatedAfterInput,
        updatedBeforeInput,
        clearSearchButton,
        searchButton,
        allDropdowns,
    } = elements;

    if (searchInput && clearSearchButton) {
        searchInput.value = getQueryParam('q') || '';

        // If the search input is not empty, show the clear button and hide the search icon
        if (searchInput.value !== '') {
            clearSearchButton.classList.remove(hiddenClass);
            searchButton.classList.add(hiddenClass);

        }
    }

    if (sortDropdown) {
        sortDropdown.value = getQueryParam('sort') || 'postDate';
    }

    if (dropdowns?.length) {
        dropdowns.forEach(dropdown => {
            const paramName = dropdown.name;
            if (paramName) {
                dropdown.value = getQueryParam(paramName) || '';
            }
        });
    }

    const allChoices = {};
    if (allDropdowns?.length) {
        allDropdowns.forEach(dropdown => {
            const choices = new Choices(dropdown, {
                searchEnabled: false
            });
            allChoices[dropdown.name] = choices;
        });
    }

    if (searchTypeRadios?.length) {
        searchTypeRadios.forEach(radio => {
            const isSelected = radio.value === getQueryParam('searchType');
            if (isSelected) {
                radio.checked = true;
            }
            if (radio.value != corporateDocsValue && !isSelected) {
                allChoices[resourceTypeParam]?.setChoiceByValue(corporateDocsValue);
                allChoices[resourceTypeParam]?.disable();
            }
        });
    }

    if (updatedAfterInput) {
        updatedAfterInput.value = getQueryParam('updated-after') || '';
    }

    if (updatedBeforeInput) {
        updatedBeforeInput.value = getQueryParam('updated-before') || '';
    }

    if (Array.from(dropdowns ?? []).filter(dropdown => dropdown.value).length || updatedAfterInput?.value || updatedBeforeInput?.value) {
        expandFilterMenu(elements.expandableFilter);
    }

    return { allChoices };
};
